var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHangup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19919_505983)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.255005,
    y: 0.796616,
    width: 25.9999,
    height: 26,
    rx: 8.31999,
    fill: "#F64A46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5207 16.3861C5.21578 15.7811 5.0851 15.4472 4.87698 14.7357C4.7463 14.2759 4.87214 13.8596 5.26418 13.4676C5.53038 13.2014 5.92242 12.9352 6.46449 12.6545L6.47418 12.6448L6.63873 12.5673C8.71024 11.5703 10.9366 11.0573 13.255 11.0524C15.5927 11.0573 17.8288 11.5703 19.9148 12.5915L20.031 12.6496C21.3716 13.3418 21.8556 13.9613 21.633 14.7357C21.4297 15.4423 21.299 15.7763 20.9893 16.3861C20.8779 16.6136 20.6989 16.7733 20.4811 16.8556C20.2246 16.9476 19.726 16.8363 19.4986 16.7637L19.1501 16.6572C18.6032 16.4878 18.032 16.3135 17.4803 16.178C17.064 16.0715 16.885 16.028 16.7446 15.9263C16.5994 15.8198 16.5413 15.7424 16.4736 15.5778C16.4106 15.4181 16.4106 15.1858 16.4155 14.6679C16.4106 14.605 16.4106 14.5469 16.4203 14.4888C16.43 14.0436 16.4397 13.7822 15.8928 13.5354C15.0555 13.2401 14.1601 13.0804 13.255 13.0562C12.3499 13.0804 11.4497 13.245 10.593 13.5402C10.0703 13.7822 10.08 14.0436 10.0945 14.4743C10.0945 14.5421 10.0993 14.605 10.0945 14.6679C10.1042 15.2003 10.0993 15.4181 10.0364 15.5778C9.96864 15.7424 9.91056 15.8198 9.76536 15.9263C9.62016 16.0328 9.42656 16.0812 9.02968 16.178C8.46341 16.3184 7.87777 16.4975 7.31633 16.6717L7.01141 16.7637C6.76941 16.8411 6.28058 16.9427 6.0289 16.8556C5.8111 16.7733 5.63686 16.6185 5.5207 16.3861Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19919_505983"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.9999,
    height: 26,
    fill: "white",
    transform: "translate(0.255005 0.796616)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHangup);
export default __webpack_public_path__ + "static/media/hangup.a59861c4ec7e22f220792433fc038590.svg";
export { ForwardRef as ReactComponent };